/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import SectionTitle from "../components/section-title";
import Datatable from "../components/datatable";
import Widget from "../components/widget";
import { toast } from "react-toastify";
import Modal2 from "./../components/confirm-delete-modal/modal-2";
import { FiX } from "react-icons/fi";
import ApiClient from "../apis/apiClient";
import "nprogress/nprogress.css";
import "../css/custome.css";
import AddHomepageBanner from "../components/homepage-banner/addHomepageBanner";
import EditHomepageBanner from "../components/homepage-banner/editHomepageBanner";
import { Redirect } from "react-router-dom";
import { checkAccess } from "../utils/common";

const FILE_URL = process.env.REACT_APP_FILE_URL;

const API_HomepageBannerList = "/admin/homepage-banner";
const API_DeleteHomepageBannerById = "/admin/homepage-banner";
const API_UpdateHomepageBannerById = "/admin/homepage-banner";

const Simple = () => {
  const [permissionsData, setPermissionsData] = useState([]);
  const [search, setSearch] = useState("");
  const adminToken = localStorage.getItem("wed_admin_token");
  const searchRef = useRef(search);

  const getAllBanners = async (limit, pageNumber) => {
    const data = "";
    const res = await ApiClient.get(
      API_HomepageBannerList + `?page=${pageNumber}&limit=${limit}`,
      data,
      `Bearer ${adminToken}`,
    );

    if (res.data.code === 200) {
      setPermissionsData(res.data.data);
    }
  };

  useEffect(() => {
    searchRef.current = search;
    getAllBanners(10, 1);
  }, [search]);

  const deleteBanner = async (bannerData) => {
    const id = bannerData.original._id;
    const data = "";
    const res = await ApiClient.delete(
      API_DeleteHomepageBannerById + "/" + id,
      data,
      `Bearer ${adminToken}`,
    );
    if (res.data.code === 200) {
      toast.success(res.data.message);
      getAllBanners(10, 1);
    } else {
      toast.error(res.data.message);
    }
  };

  const handleActive = async (status, data) => {
    let myObj = { status };
    const res = await ApiClient.patch(
      API_UpdateHomepageBannerById + "/" + data._id,
      myObj,
      `Bearer ${adminToken}`,
    );
    if (res.data.code === 200) {
      toast.success(res.data.message);
      getAllBanners(10, 1);
    } else {
      toast.error(res.data.message);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Image",
        accessor: "image",
        Cell: (data) => {
          const imageUrl = data.row.original.image
            ? `${FILE_URL}${data.row.original.image}`
            : "/images/no-image.png";
          return (
            <img
              src={imageUrl}
              alt={data.row.original.title}
              style={{ width: 50, height: 50, objectFit: "cover" }}
            />
          );
        },
      },
      {
        Header: "Order",
        accessor: "order",
      },
      {
        Header: "Status",
        id: "status",
        accessor: (str) => (str["status"] === 1 ? "Active" : "Inactive"),
        Cell: (data) => {
          const isActive = data.row.original.status === 1;
          return (
            <span
              onClick={() => handleActive(isActive ? 0 : 1, data.row.original)}
              className={`cursor-pointer ${isActive ? "text-green-600" : "text-red-600"}`}
            >
              {isActive ? "Active" : "Inactive"}
            </span>
          );
        },
      },
      {
        Header: "Action",
        id: "delete",
        accessor: (str) => {},
        Cell: (Datatable) => (
          <>
            {checkAccess(5, "edit") && (
              <EditHomepageBanner
                id={Datatable.row.original._id}
                title={"Edit Banner"}
                getApi={getAllBanners}
              />
            )}{" "}
            |{" "}
            {checkAccess(5, "delete") && (
              <Modal2
                title="Delete"
                icon={
                  <span className="h-10 w-10 bg-red-100 text-white flex items-center justify-center rounded-full text-lg font-display font-bold">
                    <FiX size={18} className="stroke-current text-red-500" />
                  </span>
                }
                body={
                  <div className="text-sm text-grey-500">
                    Are You Sure! You want to delete this Banner?
                  </div>
                }
                buttonTitle="Confirm"
                onClick={() => {
                  deleteBanner(Datatable.row);
                }}
                buttonClassName="underLineText"
              />
            )}
          </>
        ),
      },
    ],
    [],
  );

  const data = React.useMemo(() => permissionsData, [permissionsData]);
  if (adminToken === null) {
    return <Redirect to="/" />;
  } else {
    return (
      <>
        {checkAccess(5, "add") && (
          <AddHomepageBanner title={"Add Banner"} getApi={getAllBanners} />
        )}
        <div>
          <input
            className="searchCss"
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <Datatable
          columns={columns}
          data={data}
          showSelection={false}
          showPagination={true}
          showResponseData={false}
        />
      </>
    );
  }
};

const HomepageBannerPage = () => (
  <>
    <SectionTitle title="Manage Homepage Banners" subtitle="Homepage Banners" />
    <Widget>
      <Simple />
    </Widget>
  </>
);
export default HomepageBannerPage;
